export function attach401Refresh(http, {refresh, onRefreshFail, shouldRefresh}) {
  let refreshing = null

  http.interceptors.response.use(
    r => r,
    async error => {
      const original = error?.config
      const status = error?.response?.status

      if (status !== 401 || !original || original._skipRefresh || original._retried) {
        return Promise.reject(error?.response || error)
      }

      if (shouldRefresh && !shouldRefresh()) {
        return Promise.reject(error?.response || error)
      }

      original._retried = true

      try {
        refreshing = refreshing || refresh()
        await refreshing
        refreshing = null
        return http(original)
      } catch (refreshError) {
        refreshing = null
        try {
          await onRefreshFail?.()
        } catch (_) {
          // swallow — we surface the original 401 below
        }
        return Promise.reject(error?.response || error)
      }
    },
  )
}
